import { createActions } from 'redux-actions';

export const { setDeviceType } = createActions({
    SET_DEVICE_TYPE: (type) => type,
}, { prefix: 'DEVICE_DETECTOR' });
